export default function BlogName({ name, setNameOpen }) {
  return (
    <div
      className="tw-text-primary-900 hover:tw-bg-primary-200 tw-rounded-2xl tw-bg-primary-100 tw-flex tw-px-4 tw-py-2  tw-cursor-pointer"
      onClick={() => setNameOpen(name)}
      role="button"
      tabIndex={0}
    >
      <div className="tw-grow my-auto tw-font-semibold">{name}</div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="tw-w-6 tw-h-6 tw-pb-1 tw-ml-2 tw-flex-none"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
        />
      </svg>
    </div>
  );
}
